import React from "react";
import { srcSetFor, fallbackFor, aspectFor } from "photos";

/**
 * One photograph, served in the smallest format the browser understands.
 *
 * The browser walks the sources in order and takes the first type it can
 * decode, then picks a width from that source's srcset using `sizes`. AVIF is
 * roughly a quarter the weight of the JPEG, so almost every visitor gets that.
 *
 * `fetchpriority` is intentionally lowercase: React 18 forwards unknown
 * lowercase attributes to the DOM untouched, while the camelCase spelling
 * triggers a casing warning.
 */
const Photo = ({ slug, alt, sizes, priority = false, className }) => (
  <picture>
    <source type="image/avif" srcSet={srcSetFor(slug, "avif")} sizes={sizes} />
    <source type="image/webp" srcSet={srcSetFor(slug, "webp")} sizes={sizes} />
    <img
      src={fallbackFor(slug)}
      srcSet={srcSetFor(slug, "jpg")}
      sizes={sizes}
      alt={alt}
      className={className}
      style={{ aspectRatio: aspectFor(slug) }}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      fetchpriority={priority ? "high" : "auto"}
    />
  </picture>
);

export default Photo;
